import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { generateRandomToken } from '../utils/stinggenerator';
import ToastMessage from '../utils/mui/righttoptoast';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { cardDefaultPins, getPracticeId, staffFaceEnrol } from "../config/practice";
import { KeyGlyph, PlusGlyph } from "./userui";
import {
  PasswordChoice,
  PasswordDialog,
  PasswordReveal,
  generatePassword,
  passwordProblem,
  passwordUpdate,
} from "./PasswordFields";
import UserSheet, { PRIV_PAGES, privLabel } from "./UserSheet";
import { expandWritten, fetchCatalog, roleTemplateIds, sheetGroups } from "./privileges/privilegeModel";
import "./user.css";



const AddnewUser = ({ AddnewModalClose ,fetchUsersData,uploadimg}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');
  const [roles, setRoles] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [privileges, setPrivileges] = useState([]);
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
  const practiseid = getPracticeId();
  const [selectedPrivileges, setSelectedPrivileges] = useState([]);
  const [rolesData,setRolesData]=useState([]);
  const [globalError, setGlobalError] = useState('');
  const [groom,setgroom]=useState(null)
   const [file, setFile] = useState(null);       // stores the selected File object
  const [preview, setPreview] = useState(null);
  const [pwdMode, setPwdMode] = useState('auto');
  const [password, setPassword] = useState('');
  const [askChange, setAskChange] = useState(true);
  // The generated password, shown once the user exists; Done finishes up.
  const [ready, setReady] = useState(null);
  const navigate=useNavigate()
    const [emptype,setemptype]=useState('')
    const [hiredate,setHiredate]=useState()
    const dropdowntypes = ["Hourly", "Contractors", "Salaried"];
      const handleDropdownChange = (e) => {
    const value = e.target.value;
  
    setemptype(value);
  };
  const  fetchPriviData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.get(`/v1/${practiseid}/privileges/get`);
      if (response.status === 200) {
        setPrivileges(response.data); // Update state with privileges data
      } else {
        setPrivileges([]); // Empty privileges if no data is found
      }
    } catch (error) {
      console.error(error); // Log any errors
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchPriviData(); // Call fetchData when component mounts
  }, []);

  // Privileges revamp (owner 11-03): the v2 catalog's areas, labels and descriptions when it answers (user
  // admins); otherwise the v1 rows by page as before. A new user has no stored ids to lose, so Add user still
  // sends the ticked list with POST /user.
  const [catalog, setCatalog] = useState(null);
  useEffect(() => {
    let live = true;
    fetchCatalog()
      .then((cat) => { if (live && cat?.status === 200 && Array.isArray(cat.privileges)) setCatalog(cat); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handlePrivilegeChange = (e) => {
    const { value, checked } = e.target;
    
    // Add or remove the privilege id from the selected list
    if (checked) {
      setSelectedPrivileges((prevSelected) => [...prevSelected, value]);
    } else {
      setSelectedPrivileges((prevSelected) =>
        prevSelected.filter((id) => id !== value)
      );
    }
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };
  
  const validatePhone = (phone) => {
    const re = /^[0-9]{10}$/; // Validates exactly 10 digits, no spaces or letters
    return re.test(phone);
  };
  

  const fetchRolesData = async () => {
    setLoading(true); // Start loading
    try {
        const response = await api.get(`/v1/${practiseid}/roles/get`);
        if (response.status === 200) {
            setRolesData(response.data); // Update state with privileges data
        } else {
            setRolesData([]); // Empty privileges if no data is found
        }
    } catch (error) {
        console.error(error); 
    } finally {
        setLoading(false); 
    }
};
 
   useEffect(() => {
        fetchRolesData(); // Call fetchData when component mounts
    }, []);

    const handleRoleChange = (e) => {
      const selectedRoleName = e.target.value;
      setRoles(selectedRoleName);  
      const selectedRole = rolesData.find((role) => role.role === selectedRoleName);
      // Picking a role no longer ticks anything (owner 11-03): "Apply <role> template" previews it first.
      setgroom(selectedRole || null);
    };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile)); // create preview
    }
  };
    const handleNewUser = async () => {
      if (!groom) {
        return;
      }
      const token = generateRandomToken();
      const pwd = pwdMode === 'auto' ? generatePassword() : password;
      const payload = {
        "practiceid": practiseid,
        "firstname": firstName,
        "lastname": lastName,
        "email": email,
        "username": userId,
        "phone": phone,
        // 49 + 51 Attendance are one switch: write both (catalog written_with)
        "permissions": expandWritten(catalog, selectedPrivileges),
        "grole": groom.id,
        "status": status,
        "token": token,
        'pwd':pwd,
        role:''
      };
    
      try {
        const response = await api.post(`/v1/${practiseid}/user`, payload);
        if (response.status === 200) {
          fetchUsersData();
          // POST /user ignores pwd, so set it now the user exists.
          let pwdSet = false;
          try {
            const set = await api.put(`/v1/${practiseid}/user`, passwordUpdate({ id: response?.user_id, email }, pwd, askChange));
            pwdSet = set?.status === 200;
          } catch (error) {
            console.error(error);
          }
          if (pwdSet) {
            setToastMessage('Create User Successfully!');
            setToastSeverity('success');
          } else {
            setToastMessage("User created, but the password wasn't set. Use Reset password on their row.");
            setToastSeverity('error');
          }
          setOpenToast(true);
          await uploadimg({file:file,id:response?.user_id})
              await api.put(`/v1/${practiseid}/user/config`, {
                "rowid":response?.user_id,
                 "emp_type":emptype,
                 "hire_date": dayjs().format("YYYY-MM-DD"),
                 // A practice with its own default card pins (7825) saves
                 // none, so the new user gets those defaults; seeding C-HIM's
                 // [Intake, Vitals, Chart, Order] left 7825 cards with Intake
                 // alone, and nobody there has the pin menu to fix it.
                 "dash_pins": cardDefaultPins() ? [] : [
        9,
        8,
        1,
        2
    ]
                     });
          const finish = () => {
            setPreview('')
            setFile('')
            AddnewModalClose();


     
            // C-HIM's face-capture enrolment next (9928); elsewhere the
            // admin stays on the Users page.
            if (staffFaceEnrol()) navigate(
          `/onboard-emp?userid=${response?.user_id}&username=${userId}&email=${email}&phone=${phone}`
        )
          };
          if (pwdSet && pwdMode === 'auto') {
            setReady({ pwd, finish });
            return;
          }
          setTimeout(finish, 1000);
          setTimeout(() => {
            setOpenToast(false);
          }, 2000);
        } else if (response.status === 201) {
          // User already exists
          setToastMessage(response?.message||'Your user ID or email address exists');
          setToastSeverity('error');
          setOpenToast(true);
        
        } else {
          setToastMessage(response?.message||'Please select a unique user ID and Email Address');
          setToastSeverity('error');
          setOpenToast(true);
       
          console.error("Failed to assign room");
        }
      } catch (error) {
        console.error("Error assigning room:", error);
      }
    };
     
  
    const handleSave = () => {
      const newErrors = {};
      setGlobalError(''); // Reset the global error
      if (!email && !phone && !firstName && !lastName && !userId && !roles && selectedPrivileges.length === 0) {
        setGlobalError('Please select required fields');
        return; // Prevent form submission if all fields are empty
      }
      // Validate email
      if (!validateEmail(email)) {
        newErrors.email = 'Please enter a valid email.';
      }
    
      // Validate phone
      if (!validatePhone(phone)) {
        newErrors.phone = 'Please enter a valid phone number.';
      }
    
      // Validate first name
      if (!firstName) {
        newErrors.firstName = 'First name is required.';
      }
    
      // Validate last name
      if (!lastName) {
        newErrors.lastName = 'Last name is required.';
      }
    
      // Validate user ID
      if (!userId) {
        newErrors.userId = 'User ID is required.';
      }
    
      // Validate role
      if (!roles) {
        newErrors.roles = 'Role is required.';
      }
    
      const pwdProblem = passwordProblem(pwdMode, password);
      if (pwdProblem) {
        newErrors.password = pwdProblem;
      }

      // Validate privileges
      if (selectedPrivileges.length === 0) {
        newErrors.privileges = 'At least one privilege must be selected.';
      }
    
      // Only set the global error if no specific field errors exist
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        // Only show global error if no individual errors are present
        setGlobalError('');
        return; // Prevent form submission if errors exist
      }
    
      // Proceed with the save logic if no errors
      handleNewUser();
    };
    
  

  const roleObj = rolesData.find((role) => role.role === roles);
  const groups = sheetGroups({ catalog, privileges, pages: PRIV_PAGES, privLabel });
  const template = roleTemplateIds({ catalog, privileges, role: roleObj });
  const initials = `${firstName.trim().charAt(0)}${lastName.trim().charAt(0)}`.toUpperCase();

  return (
    <UserSheet
      title="Add new user"
      sub="Set their details, password and privileges."
      initials={initials}
      photo={preview}
      onPhoto={handleFileChange}
      onClose={AddnewModalClose}
      error={globalError}
      groups={groups}
      selected={selectedPrivileges}
      setSelected={setSelectedPrivileges}
      onToggle={handlePrivilegeChange}
      roleName={roles}
      template={template}
      keepIds={(catalog?.users_privilege_ids || []).map(String)}
      privError={errors.privileges}
      details={
        <>
          <div className="bmuf-grid">
            <div className={`bmuf-f${errors.firstName ? " bad" : ""}`}>
              <label htmlFor="bmuf-first">First name <span className="req">*</span></label>
              <input
                id="bmuf-first"
                type="text"
                placeholder="e.g. Bindu"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              {errors.firstName && <p className="msg">{errors.firstName}</p>}
            </div>

            <div className={`bmuf-f${errors.lastName ? " bad" : ""}`}>
              <label htmlFor="bmuf-last">Last name <span className="req">*</span></label>
              <input
                id="bmuf-last"
                type="text"
                placeholder="e.g. Pang"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              {errors.lastName && <p className="msg">{errors.lastName}</p>}
            </div>

            <div className={`bmuf-f${errors.userId ? " bad" : ""}`}>
              <label htmlFor="bmuf-uid">User ID <span className="req">*</span></label>
              <input
                id="bmuf-uid"
                type="text"
                placeholder="e.g. bindupang"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
              />
              {errors.userId && <p className="msg">{errors.userId}</p>}
            </div>

            <div className={`bmuf-f${errors.email ? " bad" : ""}`}>
              <label htmlFor="bmuf-email">Email <span className="req">*</span></label>
              <input
                id="bmuf-email"
                type="email"
                placeholder="name@clinic.org"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <p className="msg">{errors.email}</p>}
            </div>

            {/* Required: both modals turn away anything but 10 digits. */}
            <div className={`bmuf-f${errors.phone ? " bad" : ""}`}>
              <label htmlFor="bmuf-phone">Phone <span className="req">*</span></label>
              <input
                id="bmuf-phone"
                type="tel"
                placeholder="10 digits, e.g. 4325550100"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              {errors.phone && <p className="msg">{errors.phone}</p>}
            </div>

            <div className="bmuf-f">
              <label htmlFor="bmuf-status">Status</label>
              <select id="bmuf-status" value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="">Select status</option>
                <option value="A">Active</option>
                <option value="I">Inactive</option>
              </select>
            </div>

            <div className={`bmuf-f${errors.roles ? " bad" : ""}`}>
              <label htmlFor="bmuf-role">Role <span className="req">*</span></label>
              <select id="bmuf-role" value={roles} onChange={handleRoleChange}>
                <option value="">Select a role</option>
                {rolesData.map((role) => (
                  <option key={role.id} value={role.role}>
                    {role.role}
                  </option>
                ))}
              </select>
              {errors.roles && <p className="msg">{errors.roles}</p>}
            </div>

            <div className="bmuf-f">
              <label htmlFor="emptype">Employee type</label>
              <select id="emptype" value={emptype} onChange={handleDropdownChange}>
                <option value="">Select type</option>
                {dropdowntypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <h3 className="bmuf-sec">Password</h3>
          <PasswordChoice
            mode={pwdMode}
            setMode={setPwdMode}
            password={password}
            setPassword={setPassword}
            askChange={askChange}
            setAskChange={setAskChange}
            error={errors.password}
          />
        </>
      }
      footer={
        <>
          <button type="button" className="bmuf-cancel" onClick={AddnewModalClose}>
            Cancel
          </button>
          <button type="button" className="bmuf-save" onClick={handleSave}>
            {PlusGlyph} Add user
          </button>
        </>
      }
    >
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
      {ready && (
        <PasswordDialog
          icon={KeyGlyph}
          title={`${firstName} ${lastName}`.trim() + " is all set"}
          sub={[userId, email].filter(Boolean).join(" · ")}
          onClose={ready.finish}
          footer={
            <button type="button" className="bmuf-save" onClick={ready.finish}>
              Done
            </button>
          }
        >
          <div className="bmpw-done">
            <p>Copy their password and share it with them securely. It won't be shown again.</p>
            <PasswordReveal password={ready.pwd} />
          </div>
        </PasswordDialog>
      )}
    </UserSheet>
  );
};

export default AddnewUser;
